import './Header.css';
import fishLogo from '../images/fish-icon.png';
import hamborger from '../images/hamborger.png'
import { Link } from 'react-router-dom';
import { useState } from 'react';
import {useCookies} from 'react-cookie';

function Header() {

    const [navOpen, setNavOpen] = useState(false);
    const [cookie, setCookie] = useCookies(['userRole']);

    return (
        <div className='header-main'>
            <div className='header-child'>
                <img src={fishLogo} className='header-logo' alt='fish icon'/>
                <h3 className='header-text'>Fish Fry Order Taker</h3>
                <div className='hamborger-menu'>
                    <img onClick={() => setNavOpen(!navOpen)} src={hamborger} className='hamborger-icon' alt='hamburger menu' />
                    {navOpen ? 
                        <div className='hamborger-dropdown'>
                            <Link to='/home'>
                                <div className='hamborger-option'>
                                    <p className='hamborger-text'>Home</p>
                                </div>
                            </Link>
                            <Link to='/takeorder'>
                                <div className='hamborger-option'>
                                    <p className='hamborger-text'>Start Order</p>
                                </div>
                            </Link>
                            <Link to='/orders'>
                                <div className='hamborger-option'> 
                                    <p className='hamborger-text'>View Orders</p>
                                </div>
                            </Link>
                            {
                                cookie.userRole === 'admin' ? 
                                <Link to='/admin'>
                                    <div className='hamborger-option'>
                                        <p className='hamborger-text'>Admin</p>
                                    </div>
                                </Link> : null
                            }
                        </div>
                        : null}
                </div>
            </div>
        </div>
    );
}

export default Header;